import type { ClientHistoryKind } from '@fos/shared/contracts/client-notes';
import {
  Bot,
  Calendar,
  CheckCircle2,
  Clock,
  type LucideIcon,
  Mail,
  PenLine,
  ShieldCheck,
  SquareCheckBig,
  StickyNote,
  TriangleAlert,
} from 'lucide-react';

/** Fala 10: wspólne dla notatek, osi czasu klienta i Historii AI — adresy rekordów i ikony rodzajów. */

/** Adres rekordu z linku (`{ type, id, clientId? }`); null = bez własnej strony. */
export function recordHref(link: { type: string; id: string; clientId?: string | null } | null): string | null {
  if (!link) return null;
  switch (link.type) {
    case 'client':
      return `/klienci/${link.id}`;
    case 'client_note':
      return link.clientId ? `/klienci/${link.clientId}?zakladka=historia` : null;
    case 'contact':
      return link.clientId ? `/klienci/${link.clientId}` : null;
    case 'project':
      return `/projekty/${link.id}`;
    case 'task':
      return `/zadania/${link.id}`;
    case 'meeting':
      return `/spotkania/${link.id}`;
    case 'message_thread':
      return `/poczta/${link.id}`;
    case 'approval':
      return `/akceptacje/${link.id}`;
    case 'agent_run':
      return `/agenci/${link.id}`;
    case 'inbox_item':
      return `/inbox/${link.id}`;
    case 'knowledge_item':
      return `/wiedza/${link.id}`;
    case 'offer':
      return `/oferty/${link.id}`;
    case 'hosted_asset':
      return `/utrzymanie/${link.id}`;
    case 'incident':
      return `/incydenty/${link.id}`;
    case 'billing_draft':
      return `/rozliczenia/${link.id}`;
    case 'time_entry':
      return '/czas';
    case 'memory_proposal':
      return '/ustawienia/ai';
    default:
      return null;
  }
}

export const HISTORY_KIND_ICONS: Record<ClientHistoryKind, LucideIcon> = {
  note: StickyNote,
  change: PenLine,
  mail: Mail,
  meeting: Calendar,
  task: SquareCheckBig,
  time: Clock,
  approval: ShieldCheck,
  agent_run: Bot,
  event: TriangleAlert,
};

export const TASK_DONE_ICON = CheckCircle2;
